import { render, staticRenderFns } from "./extrasBlock.vue?vue&type=template&id=1febd95c&scoped=true&"
import script from "./extrasBlock.vue?vue&type=script&lang=js&"
export * from "./extrasBlock.vue?vue&type=script&lang=js&"
import style0 from "./extrasBlock.vue?vue&type=style&index=0&id=1febd95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1febd95c",
  null
  
)

export default component.exports